export default __webpack_public_path__ + "static/media/Rev Logo - green.c33f57c4.svg";